"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFetch = exports.FETCH_OPTIONS_DEFAULT = void 0;
exports.FETCH_OPTIONS_DEFAULT = { retries: 3 };
class IFetch {
    fetchJSON(url, opts = exports.FETCH_OPTIONS_DEFAULT) {
        return this.fetch(url, opts).then(res => res.data);
    }
}
exports.IFetch = IFetch;
